export default {
    intersectionObserver: function () {
      return  'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype
    },
    localStorage: () =>{
       return 'localStorage' in window
    },
    sessionStorage: () =>{
       return 'sessionStorage' in window
    }
};

